export default {
  bind(el, binding, vnode) {
    const { value } = binding
    if (!value) return
    const input = vnode.elm.children[0]
    input.addEventListener('compositionstart', () => {
      vnode.inputLocking = true
    })
    input.addEventListener('compositionend', () => {
      vnode.inputLocking = false
      input.dispatchEvent(new Event('input'))
    })
    if (value && value.toFixed > 0) { // 有小数
      const reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${value && value.toFixed}}).*$`)
      input.addEventListener('input', () => {
        if (vnode.inputLocking) {
          return
        }
        const oldValue = input.value
        let newValue = input.value
        newValue = newValue.replace(/[^\d.]/g, '')
        newValue = newValue.replace(/^\./g, '')
        newValue = newValue.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        newValue = newValue.replace(reg, '$1$2.$3')
        if (newValue) {
          const arr = newValue.split('.')
          newValue = Number(arr[0]) + (arr[1] === undefined ? '' : '.' + arr[1]) // 去掉开头多余的0
        }
        if (value) {
          const arg_max = parseFloat(value.max)
          const arg_min = parseFloat(value.min)
          if (arg_max && newValue > arg_max) {
            newValue = arg_max
          }
          if (arg_min && newValue !== '' && newValue < arg_min) {
            newValue = arg_min
          }
        }
        // 判断是否需要更新，避免进入死循环
        if (newValue !== oldValue) {
          input.value = newValue
          input.dispatchEvent(new Event('input')) // 通知v-model更新
        }
      })
      // input 事件无法处理小数点后面全是零的情况 因为无法确定用户输入的0是否真的应该清除，如3.02。放在blur中去处理
      input.addEventListener('blur', () => {
        const oldValue = input.value
        let newValue = input.value
        if (newValue) {
          newValue = Number(newValue).toString()
        }
        // 判断是否需要更新，避免进入死循环
        if (newValue !== oldValue) {
          input.value = newValue
          input.dispatchEvent(new Event('input')) // 通知v-model更新
        }
      })
    } else { // 正整数（没有小数）
      input.addEventListener('input', () => {
        if (vnode.inputLocking) {
          return
        }
        const oldValue = input.value
        let newValue = input.value.replace(/[^\d]/g, '')
        if (newValue) {
          let type = (value && value.type) || ''
          if (value && value.min === 0) {
            type = 'zeroCan'
          }
          switch (type) {
            case 'zeroBefore':
              break // 数字随意输，不做处理，如 000013
            case 'zeroCan':
              newValue = Number(newValue).toString() // 正整数 (可以输入0)
              break
            default :
              newValue = newValue.replace(/^\b(0+)/gi, '') // （默认）去掉开头0 正整数
          }
        }
        if (value) {
          const arg_max = parseInt(value.max)
          const arg_min = parseInt(value.min)
          if (arg_max && newValue > arg_max) {
            newValue = arg_max
          }
          if (arg_min && newValue !== '' && newValue < arg_min) {
            newValue = arg_min
          }
        }
        // 判断是否需要更新，避免进入死循环
        if (newValue !== oldValue) {
          input.value = newValue
          input.dispatchEvent(new Event('input')) // 通知v-model更新
        }
      })
    }
  }
}

